export default __webpack_public_path__ + "static/Access-7c3cbb59d4682220e18f05e552df7ed6.png";